import { render, staticRenderFns } from "./FloorPeopleTree.vue?vue&type=template&id=053abc75&scoped=true"
import script from "./FloorPeopleTree.vue?vue&type=script&lang=js"
export * from "./FloorPeopleTree.vue?vue&type=script&lang=js"
import style0 from "./FloorPeopleTree.vue?vue&type=style&index=0&id=053abc75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053abc75",
  null
  
)

export default component.exports